import { Helmet } from "react-helmet-async"
import "../components/Homepage/Homepage.css"
import Instructions from "../components/Broker/Instructions"

export default function Broker() {
    const schema = {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": "Salusion Administrators",
        "description": "Join Salusion’s administrators.",
        "url": "https://salusion.com/referral-program", // Add the canonical URL for this page
        "mainEntity": {
            "@type": "Service", // The referral program is a service
            "name": "Salusion Administrators",
            "description": "Join Salusion’s administrators.",
            "provider": { // The organization offering this service
                "@type": "Organization",
                "name": "Salusion, Inc.",
                "url": "https://salusion.com",
                "logo": "https://salusion.com/assets/icons/logos/favicons/mini-logo-152x152.png",
                "sameAs": [ // Add your social media profiles
                    "https://twitter.com/Salusion",
                    "https://linkedin.com/company/salusion-inc"
                ]
            },
            // The 'offers' property now correctly describes what the Service offers

        }
    };
    return (
        <>
            <Helmet>
                <title>Insurance Brokers - Support Better Benefits and Get Rewarded</title>
                <meta name="title" content="Salusion Administrator Program" />
                <meta name="description" content="Join Salusion’s Administrators" />
                <meta name="keywords" content="Salusion, referral program, HRA, employee benefits, partner, rewards" />
                <link rel="canonical" href="https://salusion.com/partners" />

                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:site" content="@Salusion" />
                <meta name="twitter:title" content="Salusion Administrator Program" />
                <meta name="twitter:description" content="Join Salusion’s administrators." />
                <meta name="twitter:image" content="https://salusion.com/assets/images/Generic.png" />
                <meta name="twitter:image:alt" content="Illustration of a hand offering money to another hand, symbolizing a reward for referrals." />

                <meta property="og:title" content="Salusion Administrator Program" />
                <meta property="og:description" content="Join Salusion’s administrators." />
                <meta property="og:image" content="https://salusion.com/assets/images/Generic.png" />
                <meta property="og:url" content="https://salusion.com/partners" />
                <meta property="og:type" content="website" />
                <meta property="og:site_name" content="Salusion" />
                <script type="application/ld+json">{JSON.stringify(schema)}</script>

            </Helmet>

            <Instructions />
        </>
    )
}
